// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xusztymyilhzvkoxnynn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh1c3p0eW15aWxoenZrb3hueW5uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3Mzk4NjMsImV4cCI6MjA3MzMxNTg2M30.Lv8rbHGy5h2gSYhgSNyUXkMLABU8OWS6u7F76dhZw-k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});